import { STATUSORDER } from "@/shared/utils/enums/statusOrder";

export const getStatus = (pq) => {
    if(pq.estado === STATUSORDER.Cotizado){
        const aprobadoAt = pq.aprobado_at ? new Date(pq.aprobado_at) : null;
        const cotizadoAt = pq.cotizado_at ? new Date(pq.cotizado_at) : null;
        if(aprobadoAt < cotizadoAt){
        return STATUSORDER.PedidoDevuelto
        }
    }
    return pq.estado;
}